export const cores = [
  "#03a9f4", // Azul claro
  "#4caf50", // Verde
  "#ffc107", // Amarelo
  "#ff9800", // Laranja
  "#ff5722", // Vermelho forte
  "#cc0000", // Vermelho escuro
  "#9e9e9e", // Cinza
  "#607d8b", // Azul acinzentado
  "#8A05BE", // Roxo Nubank
  "#CC092F", // Vermelho Bradesco
  "#FF6900", // Laranja Itaú
  "#EE3124", // Vermelho Santander
  "#FFCC29", // Amarelo Banco do Brasil
  "#005AA7", // Azul Caixa Econômica Federal
  "#FF7A00", // Laranja Banco Inter
  "#0033A0", // Azul BTG Pactual
  "#00A859", // Verde Banco Original
  "#101820" // Preto C6 Bank
];

// Ícones do seletor de categoria — todos VALIDADOS contra a fonte instalada
// (material-symbols/index.d.ts). Não adicionar nome sem conferir lá: alias
// removido da fonte renderiza como texto cru no lugar do ícone.
export const icones = [
  // Moradia e casa
  "home",
  "apartment",
  "cottage",
  "house",
  "key",
  "real_estate_agent",
  "chair",
  "bed",
  "light",
  "electrical_services",
  "water_drop",
  "gas_meter",
  "local_fire_department",
  "cleaning_services",
  "plumbing",
  "handyman",
  "construction",
  "yard",
  "deck",
  "garage_home",
  // Alimentação
  "restaurant",
  "dining",
  "fastfood",
  "lunch_dining",
  "dinner_dining",
  "breakfast_dining",
  "brunch_dining",
  "bakery_dining",
  "local_pizza",
  "ramen_dining",
  "kebab_dining",
  "icecream",
  "cake",
  "local_cafe",
  "coffee",
  "emoji_food_beverage",
  "local_bar",
  "wine_bar",
  "sports_bar",
  "liquor",
  "takeout_dining",
  "moped",
  "outdoor_grill",
  "kitchen",
  "grocery",
  "shopping_basket",
  "storefront",
  // Transporte
  "directions_car",
  "local_gas_station",
  "ev_station",
  "local_parking",
  "garage",
  "car_repair",
  "car_crash",
  "tire_repair",
  "toll",
  "directions_bus",
  "train",
  "tram",
  "subway",
  "pedal_bike",
  "two_wheeler",
  "electric_scooter",
  "local_taxi",
  "commute",
  "flight",
  "flight_takeoff",
  "luggage",
  "directions_boat",
  "sailing",
  "map",
  "local_shipping",
  "moving",
  // Saúde
  "favorite",
  "monitor_heart",
  "medical_services",
  "local_hospital",
  "emergency",
  "vaccines",
  "medication",
  "healing",
  "dentistry",
  "eyeglasses",
  "psychology",
  "psychiatry",
  "self_improvement",
  "spa",
  "bloodtype",
  "health_and_safety",
  "local_pharmacy",
  "elderly",
  "accessible",
  // Esporte e fitness
  "fitness_center",
  "exercise",
  "directions_run",
  "pool",
  "surfing",
  "hiking",
  "downhill_skiing",
  "skateboarding",
  "sports_soccer",
  "sports_basketball",
  "sports_tennis",
  "sports_volleyball",
  "sports_football",
  "sports_baseball",
  "sports_martial_arts",
  "sports_gymnastics",
  "sports_motorsports",
  "sports_esports",
  // Educação
  "school",
  "menu_book",
  "auto_stories",
  "library_books",
  "history_edu",
  "science",
  "calculate",
  "language",
  "translate",
  "edit_note",
  "workspace_premium",
  // Trabalho, renda e investimentos
  "work",
  "business_center",
  "badge",
  "engineering",
  "handshake",
  "rocket_launch",
  "attach_money",
  "payments",
  "paid",
  "wallet",
  "account_balance_wallet",
  "savings",
  "account_balance",
  "local_atm",
  "credit_card",
  "credit_score",
  "trending_up",
  "trending_down",
  "currency_exchange",
  "currency_bitcoin",
  "show_chart",
  "candlestick_chart",
  "monitoring",
  "pie_chart",
  "bar_chart",
  "price_check",
  "request_quote",
  "receipt_long",
  "receipt",
  "sell",
  "percent",
  "loyalty",
  "redeem",
  "featured_seasonal_and_gifts",
  "volunteer_activism",
  // Assinaturas e tecnologia
  "subscriptions",
  "devices",
  "computer",
  "tv",
  "live_tv",
  "movie",
  "theaters",
  "music_note",
  "headphones",
  "piano",
  "videogame_asset",
  "podcasts",
  "cloud",
  "wifi",
  "router",
  "print",
  "photo_camera",
  // Lazer e viagem
  "beach_access",
  "travel_explore",
  "celebration",
  "park",
  "forest",
  "camping",
  "attractions",
  "festival",
  "theater_comedy",
  "palette",
  "brush",
  "casino",
  "toys",
  "smart_toy",
  "nightlife",
  // Pets
  "pets",
  "sound_detection_dog_barking",
  // Família e comunidade
  "family_restroom",
  "child_care",
  "child_friendly",
  "stroller",
  "baby_changing_station",
  "diversity_3",
  "groups",
  "group",
  "person",
  "church",
  "synagogue",
  "mosque",
  "temple_buddhist",
  "temple_hindu",
  // Vestuário e cuidados pessoais
  "checkroom",
  "apparel",
  "dry_cleaning",
  "local_laundry_service",
  "content_cut",
  "face",
  "diamond",
  "watch",
  "styler",
  // Compras
  "shopping_cart",
  "shopping_bag",
  "local_mall",
  "inventory_2",
  "package_2",
  "mail",
  "local_post_office",
  // Impostos, taxas e burocracia
  "gavel",
  "local_police",
  "security",
  "verified_user",
  "shield",
  "admin_panel_settings",
  "policy",
  "assured_workload",
  // Energia e sustentabilidade
  "bolt",
  "energy_savings_leaf",
  "solar_power",
  "recycling",
  "compost",
  "eco",
  "local_florist",
  // Diversos
  "star",
  "category",
  "public",
  "smoking_rooms",
  "emoji_objects",
  "help",
  "more_horiz"
];

